import clsx from 'clsx';

interface SkeletonProps {
  className?: string;
  rounded?: 'sm' | 'md' | 'lg' | 'full';
}

const ROUNDED: Record<NonNullable<SkeletonProps['rounded']>, string> = {
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  full: 'rounded-full',
};

/**
 * Pulsing skeleton placeholder. Use these instead of spinners so the layout
 * doesn't shift when data lands — CLAUDE.md dashboard rule.
 */
export function Skeleton({ className, rounded = 'md' }: SkeletonProps) {
  return <div className={clsx('animate-pulse bg-slate-200/80', ROUNDED[rounded], className)} />;
}

/** A card-shaped skeleton matching the dashboard `.card` utility footprint. */
export function SkeletonCard({ height = 'h-40', label }: { height?: string; label?: string }) {
  return (
    <div className={clsx('card flex flex-col gap-3', height)}>
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-8 w-40" />
      <Skeleton className="h-3 w-32" />
      <div className="mt-auto flex gap-2">
        <Skeleton className="h-2 flex-1" />
        <Skeleton className="h-2 w-16" />
      </div>
      {label ? <span className="sr-only">{label}</span> : null}
    </div>
  );
}
